<template lang="pug">
	modal
		.card.text-left
			.card-header.bg-info
				button.close(@click="cerrar") &times;
			Publicacion(:publicacion="publicacion", v-if="publicacion")
</template>

<script>
import Publicacion from './publicacion'
export default {
	props: ['PublicacionID'],
	components: {
		Publicacion
	},
	data () {
		return {
			publicacion: null
		}
	},
	created () {
		this.$http.get('muro/php/api/getPublicacion.php?PublicacionID=' + this.PublicacionID)
			.then(res => {
				this.publicacion = res.data
			})
			.catch(e => {
				console.error(e)
				this.$responseError(e)
			})
	},
	methods: {
		cerrar () {
			this.$router.push('/main')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/publicacion/modalPublicacion.vue